export const TWO_TOWER_MODEL_TRIGGER = 'Two Tower Model';
